export default __webpack_public_path__ + "static/media/logo.51db34de.png";